import { render, staticRenderFns } from "./LoadingOia.vue?vue&type=template&id=2bc19c13"
import script from "./LoadingOia.vue?vue&type=script&lang=js"
export * from "./LoadingOia.vue?vue&type=script&lang=js"
import style0 from "./LoadingOia.vue?vue&type=style&index=0&id=2bc19c13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports